import axiosInstance from "../api/axiosInstance";

// The flip preview (backend utils/flipPreview, founder rule 2026-09-23):
// before a switch that changes how pairs behave is saved, dry-run tonight's
// 6 PM Promise and deal with it flipped and show what members would be told.

export const getFlipPreviewFlags = async () => {
  const res = await axiosInstance.get("/admin/settings/flip-preview-flags");
  return res?.data?.data || [];
};

export const startFlipPreview = async (flags) => {
  const res = await axiosInstance.post("/admin/settings/flip-preview", { flags });
  return res?.data?.data?.id;
};

export const getFlipPreview = async (id) => {
  const res = await axiosInstance.get(`/admin/settings/flip-preview/${id}`);
  return res?.data?.data;
};

/**
 * Start a preview and poll until it finishes (the backend caps it at ~3 min).
 * The first look is quick: a change the 6 PM tick never reads is answered at
 * once ("not modelled") without running anything.
 */
export const runFlipPreview = async (flags, { intervalMs = 2000, maxMs = 200000 } = {}) => {
  const id = await startFlipPreview(flags);
  const started = Date.now();
  let delay = 400;
  while (Date.now() - started < maxMs) {
    const wait = delay;
    await new Promise((r) => setTimeout(r, wait));
    delay = intervalMs;
    const job = await getFlipPreview(id);
    if (job && job.status !== "running") return job;
  }
  return { status: "failed", error: "The preview took too long." };
};
